import { sha256Hex } from './sha256Rex';

/** Lowercase, trim, remove spaces — formato exigido pelo Google Ads Enhanced Conversions. */
export function normalizeEmailForAds(email) {
  return (email || '').trim().toLowerCase().replace(/\s+/g, '');
}

/** E.164: +{DDI}{numero} só com dígitos, ex.: +5511987654321. */
export function normalizePhoneE164(phoneCode, phoneNumber) {
  const code = (phoneCode || '').replace(/\D/g, '');
  const number = (phoneNumber || '').replace(/\D/g, '');
  if (!code || !number) return '';
  return `+${code}${number}`;
}

/**
 * Hashes SHA-256 (hex) para Conversões otimizadas.
 * Prefira userPhoneSHA256 já calculado pelo /me quando disponível.
 */
export async function buildEnhancedConversionHashes({
  email,
  phoneCode,
  phoneNumber,
  userPhoneSHA256,
} = {}) {
  const result = {};

  const normalizedEmail = normalizeEmailForAds(email);
  if (normalizedEmail) {
    result.userEmailSHA256 = await sha256Hex(normalizedEmail);
  }

  if (userPhoneSHA256) {
    result.userPhoneSHA256 = userPhoneSHA256;
  } else {
    const phone = normalizePhoneE164(phoneCode, phoneNumber);
    if (phone) {
      result.userPhoneSHA256 = await sha256Hex(phone);
    }
  }

  return result;
}

/** Objeto user_data no formato das tags Google Ads Enhanced Conversions. */
export function toGoogleAdsUserData(hashes = {}) {
  const userData = {};
  if (hashes.userEmailSHA256) userData.email = hashes.userEmailSHA256;
  if (hashes.userPhoneSHA256) userData.phone_number = hashes.userPhoneSHA256;
  return userData;
}
